import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.scss';

import Navbar       from './components/Navbar/Navbar';
import Hero         from './components/Hero/Hero';
import Products     from './components/Products/Products';
import About        from './components/About/About';
import Projects     from './components/Projects/Projects';
import Clients      from './components/Clients/Clients';
import Testimonials from './components/Testimonials/Testimonials';
import Contact      from './components/Contact/Contact';
import Footer       from './components/Footer/Footer';

import AdminLogin         from './pages/AdminLogin';
import AdminDashboard     from './pages/AdminDashboard';
import ProductDetailPage  from './pages/ProductDetailPage';
import { getProducts } from './utils/productStore';
import { PRODUCT_BASE, PRODUCTS_HASH, findProductByRoute, productPath } from './utils/routes';
import { HOME_SEO, productsItemListSchema, useSeo } from './utils/seo';

const isLoggedIn = () => localStorage.getItem('adminLoggedIn') === 'true';

const ProtectedRoute = ({ children }) =>
  isLoggedIn() ? children : <Navigate to="/admin-panel" replace />;

const LegacyProductRedirect = () => {
  const { slug } = useParams();
  const product = findProductByRoute(getProducts(), { slug });
  return <Navigate to={product ? productPath(product) : PRODUCTS_HASH} replace />;
};

const MainSite = () => {
  useSeo({
    ...HOME_SEO,
    jsonLd: productsItemListSchema(getProducts()),
  });

  return (
    <div style={{ overflowX: 'hidden', maxWidth: '100vw' }}>
      <Navbar />
      <main>
        <Hero />
        <Products />
        <About />
        <Projects />
        <Clients />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<MainSite />} />
      <Route
        path={`${PRODUCT_BASE}/:category/:productName`}
        element={<ProductDetailPage />}
      />
      <Route path={`${PRODUCT_BASE}/:slug`} element={<LegacyProductRedirect />} />
      <Route path="/products/:slug" element={<LegacyProductRedirect />} />

      <Route path="/admin-panel" element={<AdminLogin />} />

      <Route
        path="/admin-panel/dashboard"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);

export default App;
